import type { SplitterElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'
import { useState } from 'react'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import { DEFAULT_SPLITTER_POSITION } from './SplitterConstants'
import Element from './SplitterElement'
import type { SplitterDemoType, SplitterStateType } from './splitterTypes'

const DEMO_VALUE: SplitterElementValue = {
  leftBlock: {
    image: null,
    showImage: false,
    text: textToRtValue(''),
    overlay: null,
  },
  rightBlock: {
    image: null,
    showImage: false,
    text: textToRtValue(''),
    overlay: null,
  },
  position: DEFAULT_SPLITTER_POSITION,
}

const SplitterDemo: SplitterDemoType = ({ styles, fonts, feedback }) => {
  const [state, setState] = useState<SplitterStateType | undefined>()

  const handleSetState = (value: SplitterStateType) => setState((prev) => ({ ...prev, ...value }))
  return (
    <DemoWrapper full>
      <Element
        element={{
          id: `${CONFIG_ELEMENTS.splitter.type}-demo`,
          type: CONFIG_ELEMENTS.splitter.type,
          value: DEMO_VALUE,
          style: {},
          font: {},
          feedback: {},
        }}
        feedback={feedback}
        font={fonts}
        mode={DEMO_MODE}
        setState={handleSetState}
        state={state}
        styles={{ ...styles, root: { height: 500, width: '100%' } }}
      />
    </DemoWrapper>
  )
}
export default SplitterDemo
